var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6585 7.37242L9.6585 1.24742C9.28148 0.917526 8.71852 0.917525 8.3415 1.24742L1.3415 7.37242C1.12448 7.56231 1 7.83664 1 8.125V16.6712C1 17.2235 1.44772 17.6712 2 17.6712H6C6.55228 17.6712 7 17.2235 7 16.6712V12.6712C7 12.1189 7.44772 11.6712 8 11.6712H10C10.5523 11.6712 11 12.1189 11 12.6712V16.6712C11 17.2235 11.4477 17.6712 12 17.6712H16C16.5523 17.6712 17 17.2235 17 16.6712V8.125C17 7.83664 16.8755 7.56231 16.6585 7.37242Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.a70ed55ea2badd823b301d961ffd5c09.svg";
export { ForwardRef as ReactComponent };